export default "__VITE_ASSET__DqBwOvXB__"